<template>
    <v-container grid-list-xs>
        <v-row>
            <v-col>
                <v-sheet class="pa-5" elevation="3">
                    <h4 class="mb-2 primary--text">{{ $t("results.congratulations") }}</h4>

                    <p class="mb-5">
                        {{
                            $t("results.approval-message", {
                                providerName: providerInfo.name,
                                approvalAmount: formattedApprovalAmount,
                                today: formattedTodaysDate,
                                retailerName: "Aspen Dental",
                            })
                        }}
                    </p>

                    <div v-if="$t('results.account-status-activated').length">
                        <div>
                            <h4 class="mb-5">
                                {{ $t("results.account-status-activated", { retailerName: "Aspen Dental" }) }}
                            </h4>
                        </div>
                    </div>

                    <div v-if="$t('action.viewAccountAgreement').length" class="pt-5 pb-5">
                        <Button color="secondary" rounded outlined @click="view()">
                            {{ $t("action.viewAccountAgreement") }}
                        </Button>
                    </div>

                    <p v-if="$t('results.approved.thankYou').length" class="mt-8">
                        {{ $t("results.approved.thankYou", { providerName: providerInfo.name }) }}
                    </p>

                    <h4 class="body-1-lg primary--text">{{ $t("results.same-as-cash-title") }}</h4>

                    <p v-if="isRISA" class="">
                        {{ $t("results.same-as-cash-risa")}}
                    </p>

                    <p  v-if="!isRISA" class="">
                        {{ $t("results.same-as-cash-finwise")}}
                    </p>

                    <h4 class="body-1-lg mb-2 primary--text">{{ $t("results.list-title") }}</h4>

                    <ul class="body-1 bullet-styles">
                        <li v-for="item in $t('results.approved.beforeYouLeave')">
                            {{ item }}
                        </li>
                    </ul>

                    <h4 v-if="$t('results.patient-financing-promise-title').length" class="mt-6 body-1-lg primary--text">
                        {{ $t("results.patient-financing-promise-title") }}
                    </h4>

                    <p v-if="$t('results.patient-financing-promise-body').length" class="mt-2">
                        {{ $t("results.patient-financing-promise-body") }}
                    </p>

                    <v-row justify="center">
                        <v-col class="text-right mt-6">
                            <SubmitButton class="secondary" rounded @click="finish">
                                {{ $t("action.finish") }}
                            </SubmitButton>
                        </v-col>
                    </v-row>
                </v-sheet>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import { providerState, sessionState } from "@/state"
    import { formatCurrency } from "@/util/currency"
    import Providers from "@/model/provider/Providers"
    import AutoFinishMixin from "@/components/apply/AutoFinishMixin"

    export default {
        mixins: [AutoFinishMixin],
        data() {
            return {
                providerInfo: Providers[sessionState.dynamicProviderKey.providerKey],
                formattedApprovalAmount: formatCurrency(providerState.getApplyResponse().approvedAmountCents),
            }
        },
        computed: {
            formattedTodaysDate() {
                const today = new Date()
                let day = today.getDate()
                let month = today.getMonth() + 1
                if (day < 10) {
                    day = "0" + day
                }

                if (month < 10) {
                    month = "0" + month
                }
                return month + "/" + day + "/" + today.getFullYear()
            },

            paymentPlan() {
                return providerState.getPaymentPlans(sessionState.session.providerKey)[0]
            },

            isRISA() {
                return this.paymentPlan?.typeId === 'RISA'
            },
        },
        methods: {
            view() {
                this.$router.push(`/providers/${sessionState.session.providerKey}/completeAgreement`)
            }
        },
    }
</script>
